import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_URLS } from 'src/environments/env-routes';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { NodesService } from '../services/nodes.service';

@Component({
  selector: 'app-dialog-copy-file',
  templateUrl: './dialog-copy-file.component.html',
  styleUrls: ['./dialog-copy-file.component.scss']
})
export class DialogCopyFileComponent implements OnInit {
  public selectedId: string;
  public ariane;
  public multiselect=false;
  public loading: boolean;
  public file: any;
  public lastError: string;
  public doDisplayNewFolderName: boolean;
  public lastTryDestinationId: string;
  public newName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogCopyFileComponent>,
    private api: APIHelper,
    private nodeService: NodesService
  ) {
  }

  ngOnInit() {
    this.loading = false;
    let datas=[];
    this.multiselect=this.data.multiselect;
    this.doDisplayNewFolderName = true;

    if(!this.multiselect){

  
    this.file = this.data.file;
    this.newName = '';
    this.ariane = this.nodeService.getPath(
      this.data.file.path.name,
      this.data.file.path.elements
    );
    this.selectedId = this.data.file.id;

  }else{
    for(let i = 0 ;i<this.data.files.length;i++){
        
      // datas.push({this.ariane = this.nodeService.getPath(
      //   this.data.file.path.name,
      //   this.data.file.path.elements
      // );});
    }
  }
  }

  onValidate(idDestination: string, newName = '') {
    this.loading = true;
    if(!this.multiselect){
    this.lastTryDestinationId = idDestination;
    this.doDisplayNewFolderName = false;

    const url = API_URLS.nodes.copy.replace(':elementId', this.selectedId);
    const data = {
      targetParentId: idDestination,
      name: this.file.name,
      // autoRename: true
    };

    if (newName) {
      data.name = newName;
    }

    this.api
      .requestApi({action: url, method: 'POST', datas: data})
      .then(res => {
        this.dialogRef.close(true);
      })
      .catch(err => {
        console.error(err);
        this.loading = false;
        if (err.status === 409) {
          this.lastError = 'Le nom existe déjà dans le parent cible';

          this.manageAlreadyExistingDoc();
        } else if (err.status === 403) {
          this.lastError = 'Permission refusée';
        } else {
          this.lastError = err.error.error.briefSummary;
        }
      })
      .finally(() => (this.loading = false));

    }else if (this.multiselect){
      for(let i=0;i<this.data.files.length;i++){
        const url = API_URLS.nodes.copy.replace(":elementId", this.data.files[i].entry.id);
        const data = {
          targetParentId: idDestination,
          name:  this.data.files[i].entry.name
      };
        this.api
      .requestApi({ action: url, method: "POST", datas: data })
      .then(res => {
        this.dialogRef.close({ success: true, nodes: this.data.files, destinationId:res.parentId });
      })
      .catch(err => {
        if (err.status == 409) {
          this.lastError = "Le nom existe déjà dans le dossier cible";
        } else if (err.status == 403) {
          this.lastError = "Permission refusée";
        }
      })
      .finally(() => (this.loading = false));
      }
    }
  }

  public manageAlreadyExistingDoc() {
    if (this.file.isFolder) {
      this.doDisplayNewFolderName = true;
      return;
    }

    this.lastError = '';
    this.nodeService.uploadAlreadyExistingDocument({
      fileToSend: this.file,
      destinationId: this.lastTryDestinationId
    })
      .then(async (res) => {
        this.dialogRef.close({success: true});
      })
      .catch((err) => {
        this.lastError = err;
      });
  }

  public tryWithOtherName() {
    this.onValidate(this.lastTryDestinationId, this.newName);
  }


  onCancel() {
    this.dialogRef.close(false);
  }
}
